// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"f5e06b48","513":"b7895228","787":"7af36df5"}[chunkId] + ".chunk.js";
};